var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCloseRed6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M11.9584 3.70688C12.1374 3.88587 12.1524 4.16676 12.0033 4.36277L11.9585 4.41398L8.54135 7.83231L11.9605 11.2514C12.1557 11.4467 12.1557 11.7633 11.9605 11.9586C11.7815 12.1375 11.5006 12.1525 11.3046 12.0033L11.2534 11.9586L7.83424 8.53941L4.41794 11.9576C4.22272 12.1529 3.9061 12.153 3.71083 11.9578C3.53184 11.7788 3.51684 11.4979 3.66595 11.3019L3.71069 11.2507L7.12713 7.83231L3.70992 4.41509C3.51466 4.21983 3.51466 3.90325 3.70992 3.70799C3.88891 3.529 4.16985 3.51408 4.36583 3.66324L4.41703 3.70799L7.83424 7.1252L11.2513 3.70702C11.4465 3.51172 11.7631 3.51161 11.9584 3.70688Z",
    fill: "#F5C0C0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseRed6);
export default __webpack_public_path__ + "static/media/icon-close-red6.07f14582c02061d57f3028f47829e020.svg";
export { ForwardRef as ReactComponent };